webpackJsonp([46],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isInitialized: false,
      isRequesting: false,
      dialogErrorVisible: false,
      error: {
        title: '',
        message: ''
      }
    };
  },

  computed: {
    post: {
      get: function get() {
        return this.$store.getters['wordpress/posts/selected'];
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    page: {
      get: function get() {
        return this.$store.getters['wordpress/pages/selected'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    }
  },
  methods: {
    /**
     * コンポーネント名をIDから取得
     */
    getComponentNameById: function getComponentNameById(id) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id] ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id].meta.name : null;
    },

    /**
     * コンポーネントのメタ情報をIDから取得
     */
    getComponentMetaById: function getComponentMetaById(id) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id] ? __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[id].meta : null;
    },

    /**
     * pageをWP APIに問い合わせる
     */
    // requestPage: async function (id) {
    //   if (this.page) return Promise.resolve(this.page)
    //   const response = await this.$store.dispatch('wordpress/getPage', id)
    //   if (response.error) {
    //     this.error.title = `${response.code} Error: ${response.status}`
    //     this.error.message = `固定ページ読み込み時の${response.message}`
    //     this.dialogErrorVisible = true
    //     this.isRequesting = false
    //   }
    //   return Promise.resolve(response)
    // },

    /**
     * postsをWP APIに問い合わせる
     */
    requestPosts: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(_this.posts.length > 0)) {
                              _context.next = 3;
                              break;
                            }

                            resolve(_this.posts);
                            return _context.abrupt('return', true);

                          case 3:
                            _context.next = 5;
                            return _this.$store.dispatch('wordpress/posts/fetch');

                          case 5:
                            response = _context.sent;

                            if (response.error) {
                              _this.$msgbox({
                                title: '投稿の読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x, _x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestPosts() {
        return _ref.apply(this, arguments);
      }

      return requestPosts;
    }(),

    /**
     * pagesをWP APIに問い合わせる
     */
    requestPages: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(_this2.pages.length > 0)) {
                              _context3.next = 3;
                              break;
                            }

                            resolve(_this2.pages);
                            return _context3.abrupt('return', true);

                          case 3:
                            _context3.next = 5;
                            return _this2.$store.dispatch('wordpress/pages/fetch');

                          case 5:
                            response = _context3.sent;

                            if (response.error) {
                              _this2.$msgbox({
                                title: '固定ページの読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this2.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x3, _x4) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function requestPages() {
        return _ref3.apply(this, arguments);
      }

      return requestPages;
    }(),

    /**
     * mediaをWP APIに問い合わせる
     */
    requestMedia: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!(_this3.media.length > 0)) {
                              _context5.next = 3;
                              break;
                            }

                            resolve(_this3.media);
                            return _context5.abrupt('return', true);

                          case 3:
                            _context5.next = 5;
                            return _this3.$store.dispatch('wordpress/media/fetch');

                          case 5:
                            response = _context5.sent;

                            if (response.error) {
                              _this3.$msgbox({
                                title: 'アップロード画像の読み込みに失敗しました',
                                message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                                confirmButtonText: 'OK'
                              });
                              _this3.isRequesting = false;
                              reject(response.error);
                            }
                            resolve(response);

                          case 8:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x5, _x6) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function requestMedia() {
        return _ref5.apply(this, arguments);
      }

      return requestMedia;
    }(),

    /**
     * themesをWP APIに問い合わせる
     */
    requestThemes: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!_this4.$store.getters['wordpress/status/isThemesLoaded']) {
                              _context7.next = 3;
                              break;
                            }

                            resolve(_this4.themes);
                            return _context7.abrupt('return', true);

                          case 3:
                            _context7.next = 5;
                            return _this4.$store.dispatch('wordpress/themes/fetch');

                          case 5:
                            response = _context7.sent;

                            if (!response.error) {
                              _context7.next = 11;
                              break;
                            }

                            _this4.$msgbox({
                              title: 'テーマデータの読み込みに失敗しました',
                              message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                              confirmButtonText: 'OK'
                            });
                            _this4.isRequesting = false;
                            reject(response.error);
                            return _context7.abrupt('return', false);

                          case 11:
                            _this4.$store.commit('wordpress/status/themesLoaded');
                            resolve(response);

                          case 13:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this4);
                  }));

                  return function (_x7, _x8) {
                    return _ref8.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function requestThemes() {
        return _ref7.apply(this, arguments);
      }

      return requestThemes;
    }(),

    /**
     * settingsをWP APIに問い合わせる
     */
    requestSettings: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve, reject) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (!_this5.$store.getters['wordpress/status/isSettingsLoaded']) {
                              _context9.next = 3;
                              break;
                            }

                            resolve(_this5.settings);
                            return _context9.abrupt('return', true);

                          case 3:
                            _context9.next = 5;
                            return _this5.$store.dispatch('wordpress/settings/fetch');

                          case 5:
                            response = _context9.sent;

                            if (!response.error) {
                              _context9.next = 11;
                              break;
                            }

                            _this5.$msgbox({
                              title: '設定データの読み込みに失敗しました',
                              message: response.message + '\n\n ' + response.status + ' error: ' + response.statusText,
                              confirmButtonText: 'OK'
                            });
                            _this5.isRequesting = false;
                            reject(response.error);
                            return _context9.abrupt('return', false);

                          case 11:
                            _this5.$store.commit('wordpress/status/settingsLoaded');
                            resolve(response);

                          case 13:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this5);
                  }));

                  return function (_x9, _x10) {
                    return _ref10.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function requestSettings() {
        return _ref9.apply(this, arguments);
      }

      return requestSettings;
    }(),

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getCssColorsValue: function getCssColorsValue(type) {
      return 'rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': ' + this.getCssColorsValue(type);
    },

    /**
     * テーマカラー用のCSSを用意する
     */
    getCssForThemeColors: function getCssForThemeColors() {
      var _this6 = this;

      return ['base', 'main', 'accent'].reduce(function (curr, type) {
        return curr + ('.theme-' + type + '-color {' + _this6.getThemeInlineStyle('color', type) + '}.theme-' + type + '-color-hover:hover {' + _this6.getThemeInlineStyle('color', type) + '}.theme-' + type + '-bg-color {' + _this6.getThemeInlineStyle('background-color', type) + '}.theme-' + type + '-bg-color-hover:hover {color: #fff; ' + _this6.getThemeInlineStyle('background-color', type) + '}.theme-' + type + '-border-color {' + _this6.getThemeInlineStyle('border-color', type) + '}.theme-' + type + '-fill-color {' + _this6.getThemeInlineStyle('fill', type) + '}');
      }, '');
    },

    /**
     * テーマカラー用のCSSをhead要素内のstyle要素に注入する
     */
    injectThemeColorsStyle: function injectThemeColorsStyle() {
      var head = document.head;
      var style = document.createElement('style');
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = this.getCssForThemeColors();
      } else {
        style.appendChild(document.createTextNode(this.getCssForThemeColors()));
      }
      head.appendChild(style);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/46.3c27e9b45e1d7435e60d.js